import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Navbar from './components/NavBar/navbar';
import Home from './components/Home/home';
import Footer from './components/Footer/Footer';
import About from './components/About/About';
import Services from './components/Services/Services';
import ContactUs from './components/Contact-Us/Contact-Us';
import Project from './components/Projects/Project';
import CompletedProjects from "./components/Projects/CompletedProject";
import OngoingProjects from "./components/Projects/OngoingProject";
import Ratings from "./components/Client-Corner/Rating";
import Charts from "./components/Charts/Charts";
// import BarCharts from "./components/barcharts";
// import SitePieChart from "./components/piechart";
// import SiteLineChart from "./components/linechart";
// import SiteScatterChart from "./components/scatterchart";
// import SiteSparkLineChart from "./components/sparklinechart";
import Calender from "./components/About/Calender";
import CompanyProfile from "./components/About/CompanyProfile";
import OurTeam from "./components/About/OurTeam";
import Careers from './components/About/careers';
import WhatsAppButton from "./components/WhatsAppButton";
import ConstructionPlans from "./components/construction-plans/ConstructionPlans";
import ConstructionService from "./components/Services/Construction";
import InteriorService from "./components/Services/InteriorDesign";
import ArchitectureService from "./components/Services/Architecture";
import ProjectDetails from "./components/Projects/ProjectDetails";
import SignIn from "./components/sign-in/SignIn"
import PlanDetailsPage from "./components/construction-plans/PlanDetailsPage";
import ScrollToTop from "./components/ScrollToTop";

function App() {

  return (
    <Router>
      <ScrollToTop />
      <div>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/services' element={<Services />} />
          <Route path='/contact-us' element={<ContactUs />} />
          <Route path='/project' element={<Project />} />
          <Route path='/completed-projects' element={<CompletedProjects />} />
          <Route path='/ongoing-projects' element={<OngoingProjects />} />
          <Route path='/charts' element={<Charts />} />
          <Route path='/reviews' element={<Ratings />} />
          <Route path='/calender' element={<Calender />} />
          <Route path='/company-profile' element={<CompanyProfile />} />
          <Route path='/team' element={<OurTeam />} />
          <Route path='/careers' element={<Careers />} />
          <Route path='/construction-plans' element={<ConstructionPlans />} />
          <Route path='/construction' element={<ConstructionService />} />
          <Route path='/architecture' element={<ArchitectureService />} />
          <Route path='/interior-design' element={<InteriorService />} />
          <Route path='/project/:id' element={<ProjectDetails />} />
          <Route path='/signin' element={<SignIn />} />
          <Route path='/plan-details/:category/:title' element={<PlanDetailsPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </div>
    </Router>
  );
}

export default App;
